"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __importDefault(require("date-fns/format"));
var react_1 = __importDefault(require("react"));
var react_day_picker_1 = __importDefault(require("react-day-picker"));
var Button_1 = __importStar(require("../Button"));
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
var DatePickerConfirm = /** @class */ (function (_super) {
    __extends(DatePickerConfirm, _super);
    function DatePickerConfirm(props) {
        var _this = _super.call(this, props) || this;
        _this.onDayClick = function (date) {
            _this.setState({
                value: date,
            });
        };
        _this.resetValue = function () {
            if (_this.props.onChange) {
                _this.setState({ value: undefined });
                _this.props.onChange("");
            }
        };
        _this.selectValue = function () {
            if (_this.props.onChange && _this.state.value) {
                _this.props.onChange(format_1.default(_this.state.value, "yyyy-MM-dd"), _this.state.value);
            }
        };
        _this.footerElement = function () {
            var textResetFilters = LocaleProvider_1.default.locs.datatable.filters.resetFilter;
            var textAccept = LocaleProvider_1.default.locs.datatable.filters.confirm;
            return (react_1.default.createElement("div", { className: "DayPicker-Footer-Custom" },
                react_1.default.createElement("a", { href: "javascript:void(0);", onClick: _this.resetValue }, textResetFilters),
                react_1.default.createElement(Button_1.default, { variant: Button_1.ButtonVariant.Active, onClick: _this.selectValue }, textAccept)));
        };
        _this.state = {
            value: props.value,
        };
        return _this;
    }
    DatePickerConfirm.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                value: this.props.value,
            });
        }
    };
    DatePickerConfirm.prototype.render = function () {
        var localization = __assign({}, LocaleProvider_1.default.locs.date_picker.strings);
        return (react_1.default.createElement(react_day_picker_1.default, __assign({ month: this.state.value, showOutsideDays: true, onDayClick: this.onDayClick, selectedDays: this.state.value, footerElement: this.footerElement() }, localization)));
    };
    return DatePickerConfirm;
}(react_1.default.Component));
exports.default = DatePickerConfirm;
//# sourceMappingURL=index.js.map